import { connect } from 'react-redux'
import CommmentsComponent from '../components/comments';
import * as WordCommentsActions from '../stores/word_comments/actions';
import * as PeopleSearchActions from '../stores/people_search/actions';
import * as CommentLikeActions from '../stores/comment_likes/actions';

const mapStateToProps = (state, ownProps) => {
  return {
    commentsContainer: state.default.wordComments,
    user: state.default.user,
    wordText: ownProps.wordText,
    peopleSearchObject: state.default.peopleSearch
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onResetComments: () => {
      dispatch(WordCommentsActions.reset());
    },
    onLoadComments: (wordText) => {
      dispatch(WordCommentsActions.fetch(wordText));
    },
    onSaveComment: (slug, content, wordText) => {
      dispatch(WordCommentsActions.save(slug, content, wordText));
    },
    onDeleteComment: (comment) => {
      dispatch(WordCommentsActions.destroy(comment));
    },
    onSearchForPeople: (peopleText) => {
      dispatch(PeopleSearchActions.search(peopleText));
    },
    onLikeComment: (commentId) => {
      dispatch(CommentLikeActions.like(commentId));
    },
    onUnLikeComment: (commentId) => {
      dispatch(CommentLikeActions.unLike(commentId));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommmentsComponent);



// WEBPACK FOOTER //
// ./src/containers/comments.js